import { render } from "./FilterWorld.vue?vue&type=template&id=1aa4c758"
import script from "./FilterWorld.vue?vue&type=script&lang=js"
export * from "./FilterWorld.vue?vue&type=script&lang=js"

import "./FilterWorld.vue?vue&type=style&index=0&id=1aa4c758&lang=css"
script.render = render

export default script